import { AxiosRequestConfig } from 'axios'
import { getHeaderParams } from 'helpers/requestParams'
import apiEndpoints from 'const/endPoint'
import apiRequestor from 'services/apiRequestor'
import { PoJobNamesRequest } from 'redux/poJobNames/typings'
import { TransactionResponse } from './typings'

const poJobNamesAPI = {
  updatePOJobNames: async (
    payload: PoJobNamesRequest
  ): Promise<TransactionResponse> => {
    const { accessToken, requestBody } = payload

    const headerParams = getHeaderParams(accessToken)

    const requestConfig: AxiosRequestConfig = {
      url: apiEndpoints.transactions,
      method: 'POST',
      headers: { ...headerParams },
      data: { ...requestBody }
    }

    const response = await apiRequestor<TransactionResponse>({
      requestConfig
    })

    return response.data
  }
}

export default poJobNamesAPI
